import { defineMessages } from 'react-intl';

export const displaySettingsMessages = defineMessages({
    displaySettings: {
        id: 'display-settings',
        defaultMessage: 'Display settings',
    },
    title: {
        id: 'title',
        defaultMessage: 'Title',
    },
    subtitle: {
        id: 'subtitle',
        defaultMessage: 'Subtitle',
    },
    titleColor: {
        id: 'title-color',
        defaultMessage: 'Title color',
    },
    subtitleColor: {
        id: 'subtitle-color',
        defaultMessage: 'Subtitle color',
    },
    duration: {
        id: 'display-message-duration',
        defaultMessage: 'Duration',
    },
    durationPlaceholder: {
        id: 'display-message-duration-placeholder',
        defaultMessage: 'Seconds',
    },
    durationInfo: {
        id: 'display-message-duration-info',
        defaultMessage:
            'How long the message stays on the display before it returns to the idle screen. Leave it empty for the default of 10 seconds.',
    },
    successfulEntranceMessage: {
        id: 'successful-entrance-message',
        defaultMessage: 'Successfully entrance message',
    },
    rejectedEntranceMessage: {
        id: 'rejected-entrance-message',
        defaultMessage: 'Rejected entrance message',
    },
    moveCloserToBarrierMessage: {
        id: 'move-closer-to-barrier-message',
        defaultMessage: 'Move closer to the barrier message',
    },
    successfulExitMessage: {
        id: 'successful-exit-message',
        defaultMessage: 'Successful exit message',
    },
    rejectedExitMessage: {
        id: 'rejected-exit-message',
        defaultMessage: 'Rejected exit message',
    },
    dateMessage: {
        id: 'date-message',
        defaultMessage: 'Date message',
    },
    spacesMessage: {
        id: 'spaces-message',
        defaultMessage: 'Spaces message',
    },
    lprMessage: {
        id: 'lpr-message',
        defaultMessage: 'LPR message',
    },
    ticketMessage: {
        id: 'ticket-message',
        defaultMessage: 'Ticket message',
    },
    cardMessage: {
        id: 'card-message',
        defaultMessage: 'Card message',
    },
    exitPaymentDueAmountMessage: {
        id: 'exit-payment-due-amount-message',
        defaultMessage: 'Exit payment — due amount message',
    },
    exitPaymentInsertCardMessage: {
        id: 'exit-payment-insert-card-message',
        defaultMessage: 'Exit payment — insert card message',
    },
    exitPaymentCardAcceptedMessage: {
        id: 'exit-payment-card-accepted-message',
        defaultMessage: 'Exit payment — card accepted message',
    },
    exitPaymentCardRejectedMessage: {
        id: 'exit-payment-card-rejected-message',
        defaultMessage: 'Exit payment — card rejected message',
    },
    exitPaymentPinRequestedMessage: {
        id: 'exit-payment-pin-requested-message',
        defaultMessage: 'Exit payment — PIN requested message',
    },
    exitPaymentProcessingMessage: {
        id: 'exit-payment-processing-message',
        defaultMessage: 'Exit payment — processing message',
    },
    exitPaymentConfirmedMessage: {
        id: 'exit-payment-confirmed-message',
        defaultMessage: 'Exit payment — confirmed message',
    },
    exitPaymentFailedMessage: {
        id: 'exit-payment-failed-message',
        defaultMessage: 'Exit payment — failed message',
    },
    displaySettingsCreated: {
        id: 'display-settings-created',
        defaultMessage: 'Display settings created',
    },
    displaySettingsCreatedSuccess: {
        id: 'display-settings-created-success',
        defaultMessage: 'Display settings created successfully',
    },
    displaySettingsUpdated: {
        id: 'display-settings-updated',
        defaultMessage: 'Display settings updated',
    },
    displaySettingsUpdatedSuccess: {
        id: 'display-settings-updated-success',
        defaultMessage: 'Display settings updated successfully',
    },
    spDisplay: {
        id: 'sp-display',
        defaultMessage: 'SP display',
    },
    spDisplayDescription: {
        id: 'sp-display-description',
        defaultMessage: 'Manage message templates for SP LCD displays',
    },
    huiduDisplay: {
        id: 'huidu-display',
        defaultMessage: 'HUIDU display',
    },
    huiduDisplayDescription: {
        id: 'huidu-display-description',
        defaultMessage: 'Manage message templates and colours for HUIDU LED displays',
    },
    ned200Display: {
        id: 'ned200-display',
        defaultMessage: 'NED200 display',
    },
    ned200DisplayDescription: {
        id: 'ned200-display-description',
        defaultMessage: 'Manage message templates and colours for NED200 LED displays',
    },
    ned200cDisplay: {
        id: 'ned200c-display',
        defaultMessage: 'NED200c display',
    },
    ned200cDisplayDescription: {
        id: 'ned200c-display-description',
        defaultMessage: 'Manage message templates and colours for NED200c colour LED displays',
    },
    chooseDisplayType: {
        id: 'choose-display-type',
        defaultMessage: 'Choose a display type',
    },
    chooseDisplayTypeDescription: {
        id: 'choose-display-type-description',
        defaultMessage: 'Select the display model to configure its message templates',
    },
});
